import Home from "./Home.jsx";
import Fleet from "./Fleet.jsx";
import About from "./About.jsx";
import Contact from "./Contact.jsx";
import Privacy from "./Privacy.jsx";
import Terms from "./Terms.jsx";

/* ============================================================================
   PAGE REGISTRY — the one place a page is declared.

   To add a page:
     1. create src/pages/YourPage.jsx exporting a component that takes { go }
     2. import it above
     3. add an entry below

   Everything else follows automatically: the header nav, the footer quick
   links, the router in App.jsx, and the document title / meta description.

   nav: true  → appears in the header and footer link lists
   nav: false → reachable only by a direct go("key") call (legal pages)
   ========================================================================== */

export const PAGES = {
  home: {
    label: "Home",
    nav: true,
    component: Home,
    title: "A4 Express | Transport & Logistics Across the UK & Ireland",
    description:
      "Dependable courier and heavy goods transportation throughout the United Kingdom and Ireland, from 3.5 tonne electric vans to 44 tonne articulated units.",
  },
  fleet: {
    label: "Our Fleet",
    nav: true,
    component: Fleet,
    title: "Our Fleet | A4 Express",
    description:
      "Articulated trucks, 7.5 tonne vehicles, 3.5 tonne vans and electric E3.5 vehicles — capacities, capabilities and typical use.",
  },
  about: {
    label: "About Us",
    nav: true,
    component: About,
    title: "About Us | A4 Express",
    description:
      "Our mission, vision, core values, safety standards and customer commitment as a UK and Ireland transport operator.",
  },
  contact: {
    label: "Contact",
    nav: true,
    component: Contact,
    title: "Contact | A4 Express",
    description:
      "Request a transport quotation. Courier and heavy goods transport across the UK and Ireland.",
  },
  privacy: {
    label: "Privacy Policy",
    nav: false,
    component: Privacy,
    title: "Privacy Policy | A4 Express",
    description: "How A4 Express Ltd handles personal data.",
  },
  terms: {
    label: "Terms & Conditions",
    nav: false,
    component: Terms,
    title: "Terms & Conditions | A4 Express",
    description: "Terms and conditions of carriage and website use.",
  },
};

export const DEFAULT_PAGE = "home";

/** [key, label] pairs for the header and footer link lists. */
export const NAV = Object.entries(PAGES)
  .filter(([, p]) => p.nav)
  .map(([key, p]) => [key, p.label]);

export default PAGES;
